export default "__VITE_ASSET__4679a9d0__"